import React, { useEffect, useState } from "react"
import moment from "moment"
import Send from "../../core/communication"
import CalendarScreen from "../../screen/CalendarScreen"
import { useForm } from "react-hook-form"
import { useSelector } from "react-redux"
import {
  checkDate,
  formatDateCalendarEvents,
  resetFieldsCalendar,
  setPreValuesDateSelect,
  setPreValuesEventClick,
  typeEventsCalendar,
} from "../../core/utils/calendar/calendarUtils"
import { useEvents, useEventsPost, useEventsSector } from "../../core/utils/hooks/useEvents"
import { optionsEvents } from "../../core/mocks/calendar/options"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { customToast } from "../../components/Toast"
import { isMobile } from "react-device-detect"

const CalendarContainer = () => {
  const [calendarEvents, setReload] = useEvents()
  const { scope, scopeType, projectsByScope } = useScope()
  const user = useUser()

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    getValues,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  })

  const [reloadEvents, setReloadEvents] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingRemove, setLoadingRemove] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loadingEvent, setLoadingEvent] = useState(false)
  const [loadingEventSector, setLoadingEventSector] = useState(false)
  const [allPosts, setAllPosts] = useState([])
  const [eventsDate, setEventsDate] = useState([])
  const [posts, setPosts] = useState([])
  const [eventClickInfo, setEventClickInfo] = useState({})
  const [eventId, setEventId] = useState("")
  const [selectedOption, setSelectedOption] = useState("")
  const [typeEvent, setTypeEvent] = useState("")
  const [currentDateOnClick, setCurrentDateOnClick] = useState("")
  const [colorEvent, setColorEvent] = useState("#dc3545")
  const { tags, users } = useSelector((state) => state.app)
  const [tagsProject, setTagsProject] = useState([])
  const [values, setValues] = useState({})
  const [userTagsToEventSectorSave, setUserTagsToEventSectorSave] = useState([])
  const [tagsToEventProject, setTagsToEventProject] = useState([])
  const [tagsUsers, setTagsUsers] = useState([])
  const [selectedProject, setSelectedProject] = useState(null);
  const {
    typeEventContent,
    typeEventTrailOrContent,
    typeEventTrail,
    typeEventSector,
    typeEventEsm,
  } = typeEventsCalendar(typeEvent)
  const { selectedPosts, setSelectedPosts } = useEventsPost(eventId, typeEvent)
  const { receivedEventsSectorId, isRemoveSectorEvent } = useEventsSector(eventId, setValue)

  const formatCurrentDateClicked = moment(currentDateOnClick).format("YYYY-MM-DD")

  const tagsFormatToSave = values?.tags && values?.tags?.length ? 
  JSON.stringify(values?.tags?.map(({ value, label }) => ({ id: value, name: label }))): "[]"

  const watchRecurrenceField = watch("recurrence")
  const watchTagsEvent = watch("tagsEvent")
  const watchUsersEvent = watch("usersEvent")

  useEffect(() => {
    if (watchTagsEvent && watchUsersEvent) {
      setUserTagsToEventSectorSave({ tags: [], users: [] })
      setTagsUsers({ tags: watchTagsEvent, users: watchUsersEvent })
      setModalIsOpen(true)
    }
  }, [watchTagsEvent, watchUsersEvent])

  useEffect(() => {
    const farmHeader = document.querySelector(".header-nav")

    if (farmHeader && isMobile) {
      farmHeader.style.display = "none"
    }
  }, [])

  useEffect(() => {
    setEventsDate(formatDateCalendarEvents(calendarEvents, formatCurrentDateClicked))
  }, [currentDateOnClick, calendarEvents, reloadEvents])

  useEffect(() => {
    typeEventContent ? setValue("recurrence", "1") : (setSelectedPosts([]), setAllPosts([]))

    if (typeEventTrailOrContent || typeEventSector || typeEventContent) {
      getTagsByProject()
    }
  }, [typeEvent])

  useEffect(() => {
    watchRecurrenceField <= 0 && setValue("recurrence", "")
  }, [watchRecurrenceField])

  const reloadData = () => {
    setSelectedProject()
    setReload((prev) => !prev)
  }

  const handleChangeOptionsEvent = (e) => {
    setSelectedOption(e.value)
    setTypeEvent(e.label)
  }

  const onChange = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const handleEventClick = async (clickInfo) => {
    setLoadingEvent(true)
    setLoadingEventSector(true)
    const { id, extendedProps, backgroundColor } = clickInfo.event;
    const { description, type, recurrence, tags } = extendedProps;
  
    setTypeEvent(type);
    setEventId(id);
    setPreValuesEventClick(setValue, description, type, setEventClickInfo, clickInfo, recurrence);
    const selectedOption = optionsEvents.find((item) => item.description === type)?.id;
    setSelectedOption(selectedOption);
    setColorEvent(backgroundColor);

    if (id && extendedProps && type !== 'Mudança de setor') {
      const tagsValue = tags?.length
        ? {tags: JSON.parse(tags).map(({ name, id }) => ({ value: id, label: name }))}
        : {};

      setTagsToEventProject(tagsValue)
      setModalIsOpen(true);
    }

    if (id && extendedProps && type === 'Mudança de setor') {
      setModalIsOpen(true);
    }
    
    setLoadingEventSector(false)
    setLoadingEvent(false)
  };

  const handleDateSelect = (event) => {
    setModalIsOpen(true)
    setPreValuesDateSelect(setValue, event, setEventClickInfo, user, scope)
    setSelectedPosts([])
  }

  const handleSaveOrUpdate = async (value) => {
    const hasFixedHour = typeEventTrailOrContent;
    const { title, description, start, start_time, end_time, end, color, recurrence } = value;
  
    const { startTime, endTime } = checkDate(
      start,
      start_time,
      end,
      end_time,
      hasFixedHour && "06:00:00"
    );
  
    const formattedData = {
      title,
      description,
      recurrence,
      color: colorEvent || color,
      startTime,
      endTime,
      type: typeEvent,
    };
  
    setLoading(true);
  
    try {
      if (eventClickInfo.state === "create") {
        await handleSave(formattedData);
      } else if (eventClickInfo.state === "update") {
        await handleUpdate(formattedData);
      }
      setReloadEvents(true);
    } finally {
      setLoading(false);
    }
  };
  
  const handleSave = async (data) => { // Alterar projeto Selecionado quando for Grupo ou Empresa
    const { title, description, startTime, endTime, color, recurrence } = data;
  
    if(!selectedProject) {
      customToast('Selecione o projeto', 'error');
      return;
    }

    const formattedData = {
      title,
      start: startTime,
      end: endTime,
      color,
      description,
      type: typeEvent,
      userId: user.id,
      recurrence,
      projectId: selectedProject?.value,
      posts: allPosts,
      tags: tagsFormatToSave,
    };
  
    try {
      setLoading(true);
      await Send.post("/events", formattedData);
      reloadData();
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const handleUpdate = async (data) => {
    const { title, description, startTime, endTime, scaleActionId, color, type, recurrence } = data;
    const event = eventClickInfo.clickInfo.event;

    if(!selectedProject) {
      customToast('Selecione o projeto', 'error');
      return;
    }
  
    event?.setStart(startTime);
    event?.setEnd(endTime);
    event?.mutate({
      standardProps: {
        title,
        description,
      },
    });
    event.setProp("backgroundColor", event.backgroundColor || colorEvent);
  
    const dataToUpdate = {
      title: title || "",
      start: startTime,
      end: endTime,
      color,
      description: watch("description") || "",
      type,
      recurrence: watch("recurrence") || recurrence || "0",
      userId: user.id,
      scaleActionId: typeEventEsm ? scaleActionId : null,
      projectId: scope?.id,
      posts: selectedPosts || allPosts,
      tags: tagsFormatToSave,
    };
  
    const dataToUpdateEventSector = {
      [isRemoveSectorEvent ? "dateToRemove" : "dateToAdd"]: moment(data?.startTime).format(
        "YYYY-MM-DD"
      ),
      [isRemoveSectorEvent ? "tagsToRemove" : "tagsToAdd"]: userTagsToEventSectorSave.tags,
      userIds: userTagsToEventSectorSave.users,
    };
  
    try {
      const [eventResponse, eventSectorResponse] = await Promise.all([
        Send.put(`/events/${eventId}`, dataToUpdate),
        Send.put(`/events-sector/${receivedEventsSectorId}`, dataToUpdateEventSector),
      ]);
  
      if (eventResponse.status === "error" || eventSectorResponse.status === "error") {
        throw new Error(eventResponse?.message || eventSectorResponse?.message);
      }
  
      customToast("Evento atualizado", "success");
      closeModal();
      reloadData();
    } catch (error) {
      customToast("Erro ao atualizar Evento", "error");
      closeModal();
    }
  };

  const handleChangeProject = (value) => {
    setSelectedProject(value);
  }

  const handleRemoveEvent = async () => {
    eventClickInfo.clickInfo.event.remove()

    setLoadingRemove(true)
    const response = await Send.delete(`/events/${eventId}`)

    if (response) {
      reloadData()
    }

    setLoadingRemove(false)
    setReloadEvents(true)
    closeModal()
  }

  const closeModal = () => {
    if (!loading) {
      setModalIsOpen(false)
    }
    resetFieldsCalendar(
      setValue,
      setAllPosts,
      setTagsProject,
      setEventClickInfo,
      reset,
      setEventId,
      setSelectedPosts,
      setSelectedOption,
      setTypeEvent,
    )
  }

  const getTagsByProject = () => {
    const tagsToEventProject = tags?.filter((item) => item?.projectId === scope?.id || item.projectId === "");
    setTagsProject(tagsToEventProject);
  };

  return (
    <CalendarScreen
      {...{
        getValues: getValues(),
        users,
        register,
        errors,
        watch,
        isValid,
        eventClickInfo,
        setModalIsOpen,
        modalIsOpen,
        closeModal,
        handleRemoveEvent,
        handleEventClick,
        setColorEvent,
        handleChangeOptionsEvent,
        posts,
        setPosts,
        selectedOption,
        selectedPosts,
        setSelectedPosts,
        setAllPosts,
        allPosts,
        handleDateSelect,
        setCurrentDateOnClick,
        currentDateOnClick,
        eventsDate,
        calendarEvents,
        formatCurrentDateClicked,
        loading,
        loadingRemove,
        tagsProject,
        onChange,
        values,
        control,
        eventId,
        typeEvent,
        typeEventTrail,
        typeEventTrailOrContent,
        typeEventSector,
        typeEventContent,
        tagsToEventProject,
        tagsUsers,
        loadingEvent,
        selectedProject,
        projectsByScope,
        handleChangeProject,
      }}
      handleSubmit={handleSubmit(handleSaveOrUpdate)}
    />
  )
}

export default CalendarContainer
